export default "__VITE_ASSET___MgVtoI0__"